import classNames from 'classnames';
import * as React from 'react';
import { withConfigConsumer } from '../config-provider/context';
import Skeleton from '../skeleton';
import useBuriedPoint from '../_util/hooks/useBuriedPoint';
import StatisticNumber from './Number';
const Statistic = (props) => {
    const { prefixCls, className, style, valueStyle, value = 0, title, valueRender, prefix, suffix, loading = false, direction, onMouseEnter, onMouseLeave, decimalSeparator = '.', groupSeparator = ',', } = props;
    useBuriedPoint('Statistic');
    const valueNode = (React.createElement(StatisticNumber, Object.assign({ decimalSeparator: decimalSeparator, groupSeparator: groupSeparator }, props, { value: value })));
    const cls = classNames(prefixCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
    }, className);
    return (React.createElement("div", { className: cls, style: style, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        title && React.createElement("div", { className: `${prefixCls}-title` }, title),
        React.createElement(Skeleton, { paragraph: false, loading: loading, className: `${prefixCls}-skeleton` },
            React.createElement("div", { style: valueStyle, className: `${prefixCls}-content` },
                prefix && React.createElement("span", { className: `${prefixCls}-content-prefix` }, prefix),
                valueRender ? valueRender(valueNode) : valueNode,
                suffix && React.createElement("span", { className: `${prefixCls}-content-suffix` }, suffix)))));
};
const WrapperStatistic = withConfigConsumer({
    prefixCls: 'statistic',
})(Statistic);
export default WrapperStatistic;
